import { useEffect, useMemo, useState } from "react";
import styles from "./transfer.module.scss";
import Modal from "../../../../components/Modal/Modal";
import SelectShared from "../../../../components/Select/Select";
import ButtonShared from "../../../../components/Button/Button";
import { useToast } from "../../../../helpers/hooks";
import { MyPublicationTransferProps } from "../../../../interfaces/pages";
import { useNavigate } from "react-router-dom";
import { capitalize } from "../../../../helpers/app";

const Transfer = ({
    item,
    open,
    setOpen,
    transfer,
    putTransferPublication,
    getSellers,
    cleanTransferPublication,
    getMyPublicationsRequest
}: MyPublicationTransferProps) => {
    const toast = useToast();
    const navigate = useNavigate();

    const [branchSelected, setBranchSelected] = useState<any>({value: "", error: ""});
    const [sellerSelected, setSellerSelected] = useState<any>({value: "", error: ""});

    const handlePressTransfer = () => {
        if(item?.in_transaction || item?.reserved){
            return toast("No puedes transferir una publicación en transacciôn");
        }
        putTransferPublication(item?._id, sellerSelected?.value);
    }

    const handleChangeBranch = (value: any) => {
        setBranchSelected({...branchSelected, value: value});
        const branchFounded = branchOptions.find((item: any) => item?.name === value);
        if(branchFounded){
            getSellers(branchFounded?.id, "branch");
        }
    }

    const branchOptions: any = useMemo(() => {
        return transfer?.branches?.data && transfer?.branches?.data.map((branch: any) => (
            {
                id: branch?._id,
                name: branch?.name
            }
        ))
    }, [transfer?.branches?.data]);

    const sellerOptions: any = useMemo(() => {
        return transfer?.sellers?.data && transfer?.sellers?.data.map((seller: any) => (
            {
                id: seller?._id,
                name: `${capitalize(seller?.name)} ${capitalize(seller?.last_name)} `
            }
        ))
    }, [transfer?.sellers?.data]);

    useEffect(() => {
        if(transfer?.fetching === "failure"){
            toast("Ha ocurrido un error al transferir tu publicación");
            cleanTransferPublication();
        }
        if(transfer?.fetching === "success"){
            toast("Acabas de transferir tu publicación");
            getMyPublicationsRequest();
            setOpen(false);
            cleanTransferPublication();
            navigate("/profile/my_publications");
        }
    }, [transfer?.fetching]);

    useEffect(() => {
        if(!open){
            setBranchSelected({value: "", error: ""});
            setSellerSelected({value: "", error: ""});
        }
    }, [open]);

    return (
        <Modal open={open} variant="white" className={`${styles.modalContainer} ${styles.transferModal}`}>
            <p className={styles.title}>
                <span className={styles.message}>Estás a punto de transferir la publicación del vehículo</span>
                <span className={styles.name}>{item?.title}</span>
                <span className={styles.message}>Elige la sucursal y nombre de la persona que lo recibirá</span>
            </p>
            <SelectShared
                label="Sucursal"
                name="branchInput"
                value={branchSelected?.value}
                className={styles.select}
                onChange={(value: any) => handleChangeBranch(value)}
                options={branchOptions}
                loading={transfer?.branch?.fetching === "loading"}
                keyValue="name"
                error={branchSelected?.error && branchSelected?.error}
            />
            <SelectShared
                label="Vendedor"
                name="sellerInput"
                value={sellerSelected?.value}
                className={styles.select}
                onChange={(value: any) => setSellerSelected({...sellerSelected, value: value})}
                options={sellerOptions}
                loading={transfer?.sellers?.fetching === "loading"}
                keyValue="id"
                error={sellerSelected?.error && sellerSelected?.error}
                optionsEmptyMessage={branchSelected?.value.length > 0 && sellerOptions.length === 0 ? "No hay vendedores para esta sucursal" : "Debes seleccionar una sucursal"}
            />
            <div className={styles.buttons}>
                <ButtonShared 
                    onPress={() => setOpen(false)}
                    title="Regresar" 
                    tertiary
                    size="small"
                />
                <ButtonShared 
                    onPress={() => handlePressTransfer()}
                    title="Transferir" 
                    primary
                    size="small"
                    loading={transfer?.fetching === "loading"}
                />
            </div>
        </Modal>
    )
}

export default Transfer;